import * as React from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { withRouter } from 'react-router-dom';
import { TranslateProps } from 'util/i18n';
import { translate } from 'react-i18next';
import { LayoutSize } from 'types';
import { setLayout } from 'actions/monitoringActions';
import { State } from 'reducers';
import { getLayout } from 'selectors/monitoringSelectors';
import { toUrl } from './Navigation';
import { Fade } from 'ui/transitions';

type RouterProps = RouteComponentProps<any>; // tslint:disable-line:no-any

export const LayoutOptionsComponent = ({ size, visible, onClickSize }: OwnProps & StateProps & DispProps) =>
    <Fade visible={ visible } duration={ 200 }>
        <ul id="layout-options">
            { [1, 4, 9, 16].map((n: LayoutSize) =>
                <li key={ `size${n}` }>
                    <a id={ `layout-option-${n}` } onClick={ onClickSize(n) } className={ n === size ? 'selected' : undefined }>
                        { n }
                    </a>
                </li>
            ) }
        </ul>
    </Fade>
;

export type OwnProps = {
};
export type StateProps = {
    size: LayoutSize;
    visible: boolean;
};
export type DispProps = {
    onClickSize: (size: LayoutSize) => () => void;
};

const mapStateToProps = (state: State, { location, t }: OwnProps & RouterProps & TranslateProps): StateProps => ({
    size: getLayout(state),
    visible: location.pathname.indexOf(toUrl('monitoring')) === 0, // Only show when the Monitoring page is active
});

const mapDispatchToProps = (dispatch: Function): DispProps => ({
    onClickSize: size => () => dispatch(setLayout(size)),
});

export const LayoutOptions = compose<OwnProps & StateProps & DispProps, OwnProps>(
    withRouter,
    translate(),
    connect(mapStateToProps, mapDispatchToProps),
)(LayoutOptionsComponent);



// WEBPACK FOOTER //
// ./src/ui/main/header/LayoutOptions.tsx